module.exports = __webpack_public_path__ + "img/home_background1.78c39e0f.jpg";